import { useSuspenseQuery } from "@apollo/client";
import { graphql } from "@/shared/gql";
import { getPreloadQuery } from "@/shared/gql/apollo-client";

const FetchSourcingWebsite = graphql(`
  query FetchSourcingWebsite($id: ID!) {
    superAdmin {
      sourcingWebsite(id: $id) {
        id
        name
        url
        domain
        urlStatus
        bestRelevance
        lastDiscoveredAt
        lastExtractedAt
        acknowledgedNoTendersAt
        createdAt
        organisation {
          id
          name
        }
      }
    }
  }
`);

export const useFetchSourcingWebsite = (id: string) =>
  useSuspenseQuery(FetchSourcingWebsite, { variables: { id } }).data.superAdmin
    .sourcingWebsite;

export const preloadSourcingWebsite = (id: string) => {
  getPreloadQuery()(FetchSourcingWebsite, { variables: { id } });
};
